export type SomethingWentWrongProps = unknown

export const SOMETHING_WENT_WRONG_GLOBAL_ID = 'something-went-wrong'
